













































































import { CognitoUser } from "@aws-amplify/auth";
import { namespace } from "vuex-class";
import { Component, Mixins } from "vue-property-decorator";

import AlertList from "@/components/AlertList.vue";
import HasAlerts from "@/mixins/HasAlerts.vue";
import PredictiveInput from "@/tools/msa/components/PredictiveInput.vue";

const AuthStore = namespace("auth");

@Component({
  components: { PredictiveInput, AlertList }
})
export default class Login extends Mixins(HasAlerts) {
  private username: string = "";

  private password: string = "";

  private status: "Idle" | "Loading" = "Idle";

  @AuthStore.Action("update")
  private update!: (raw: CognitoUser | null) => void;

  async login() {
    try {
      this.status = "Loading";

      if (this.$auth.user()) {
        try {
          await this.$auth.signOut({ global: true });
        } catch (ex) {
          // DON'T DO ANYTHING
        }
      }

      const user = await this.$auth.signIn(this.username, this.password);

      this.update(user);

      if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
        this.flash(
          {
            type: "info",
            message: "We just need some details to complete your sign up."
          },
          { global: true }
        );
        this.$router.push("/finish");
      } else if (user.challengeName === "SMS_MFA") {
        this.flash(
          {
            type: "info",
            message: `Enter the code we sent to ${
              user.challengeParam.CODE_DELIVERY_DESTINATION
            } to complete sign-in.`
          },
          { global: true }
        );
        this.$router.push("/complete-mfa");
      } else if (user.challengeName === "SOFTWARE_TOKEN_MFA") {
        this.flash(
          {
            type: "info",
            message: "Enter an MFA code to complete sign-in."
          },
          { global: true }
        );
        this.$router.push("/complete-mfa");
      } else {
        this.update(await this.$auth.signIn(this.username, this.password));

        this.$router.push("/");
      }
    } catch (ex) {
      this.flash({ type: "danger", message: ex.message || ex });
    } finally {
      this.status = "Idle";
    }
  }
}
